// Maccsbox TicketTypeCd (interface field code_ticket_type). The numeric value IS the code, zero-padded
// to two digits in the figures file, so the enum doubles as the code table: append, never renumber
// (PAUL-3449).
export enum MaccsBoxTicketType {
  Normal = 0,
  Discount = 1,
  MaDiWoDo = 2,
  Free = 3,
  Other = 4,
}

// Free and MaDiWoDo are derived from the sale by the backend and rejected on a rule (400
// maccsbox_ticket_type_not_selectable), so they never appear in a select.
export const maccsBoxTicketTypeSelectable: MaccsBoxTicketType[] = [
  MaccsBoxTicketType.Normal,
  MaccsBoxTicketType.Discount,
  MaccsBoxTicketType.Other,
];

// Nested under ticket_types (plural): maccsbox_reports.ticket_type is already the string header of the
// sent-file preview and a key cannot be both a string and an object.
export const maccsBoxTicketTypeTranslations: Record<MaccsBoxTicketType, string> = {
  [MaccsBoxTicketType.Normal]: 'maccsbox_reports.ticket_types.normal',
  [MaccsBoxTicketType.Discount]: 'maccsbox_reports.ticket_types.discount',
  [MaccsBoxTicketType.MaDiWoDo]: 'maccsbox_reports.ticket_types.madiwodo',
  [MaccsBoxTicketType.Free]: 'maccsbox_reports.ticket_types.free',
  [MaccsBoxTicketType.Other]: 'maccsbox_reports.ticket_types.other',
};
